import type { CTASection } from "@/types/content";

interface Props {
  section: CTASection;
}

export default function CTASectionBlock({ section }: Props) {
  return (
    <section className="relative w-full py-16 md:py-24 flex items-center justify-center overflow-hidden">
      {section.backgroundImage && (
        <img
          loading="lazy"
          src={section.backgroundImage}
          alt={section.title}
          className="absolute inset-0 w-full h-full object-cover"
        />
      )}
      <div className="absolute inset-0 bg-slate-900/70" />
      <div className="relative z-10 text-center px-4 md:px-8 max-w-2xl mx-auto">
        <h2 className="text-2xl md:text-4xl font-bold text-white mb-4">
          {section.title}
        </h2>
        {section.subtitle && (
          <p className="text-base md:text-lg text-white/80 mb-8">
            {section.subtitle}
          </p>
        )}
        <a
          href={section.buttonHref}
          className="inline-block px-8 py-3 bg-primary text-white font-medium rounded-full hover:bg-primary-dark transition-colors whitespace-nowrap"
        >
          {section.buttonLabel}
        </a>
      </div>
    </section>
  );
}